import { createSvgIcon } from '@mui/material/utils';

// MUI's Keyboard icon path plus a diagonal stripe matching the style
// LayersClear uses to convey a "disabled / locked" state.
export const KeyboardOff = createSvgIcon(
  <>
    <path d="M20 5H4c-1.1 0-1.99.9-1.99 2L2 17c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m-9 3h2v2h-2zm0 3h2v2h-2zM8 8h2v2H8zm0 3h2v2H8zm-1 2H5v-2h2zm0-3H5V8h2zm9 7H8v-2h8zm0-4h-2v-2h2zm0-3h-2V8h2zm3 3h-2v-2h2zm0-3h-2V8h2z" />
    <path d="M3.27 1 2 2.27 21.73 22 23 20.73Z" />
  </>,
  'KeyboardOff',
);
